// extracted by mini-css-extract-plugin
export default {"infos":"EntityCardHeader_infos__Ia+1r","inactive":"EntityCardHeader_inactive__ej3OK"};